import { DestroyRef, inject, Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { Router } from "@angular/router";

import { ENVIRONMENT, Environment } from 'libs/core/auth/auth.tokens';
@Injectable({ providedIn: "root" })
export class PosthogService {
  private options: Environment = inject(ENVIRONMENT);
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    this.initPostHog();
  }
  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(this.options.postHogKey, {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2026-01-30',
        person_profiles: 'identified_only', 
      });
    });
  }
}